import { NavLink, Outlet } from "react-router-dom";
import {
  DropdownContent,
  DropdownItem,
  DropdownItemIcon,
  DropdownRoot,
} from "../../components/dropdown/Dropdown";
import NavDropdown from "../../components/nav/NavDropdown";
import OpretKursusLinje from "../../components/wizards/OpretKursus/OpretKursusLinje";
import Pagination from "../../components/pagination/IndexPagination";
import DownloadListIcon from "../../components/icons/DownloadListIcon";
import HandlingerDropdownTrigger from "../../components/Table/HandlingerDropdownTrigger";
import AutoCompleteKursusLinje from "../../components/autocomplete/AutoCompleteKursusLinje";
import { useRouter } from "../../hooks/useRouter";
import { useContext } from "react";
import { UserQueryContext } from "../../context/UserContext";
import AccessDenied from "../../components/AccessDenied";

export default function KursusLinjeLayoutCommon() {
  const { user, hasPermission } = useContext(UserQueryContext);
  if (!hasPermission(user, "KursusRead")) return <AccessDenied />;
  return (
    <>
      <meta name="theme-color" content="#34098d" />
      <div className="l-main">
        <header className="navbar">
          <NavDropdown />
          <AutoCompleteKursusLinje sizeLarge />
          {hasPermission(user, "KursusWrite") ? (
            <OpretKursusLinje />
          ) : (
            <div></div>
          )}
        </header>
        <Outlet />
      </div>
    </>
  );
}

interface IKursusLinjeNavHeaderProps {
  onPreviousClick: () => void;
  onNextClick: () => void;
  pageInfo: any;
  totalCount: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  page: number;
  type: "kurser" | "linjer";
  selectedIds: string[];
  allSelected: boolean;
  downloadToExcel: () => void;
}
export function KursusLinjeNavHeader(props: IKursusLinjeNavHeaderProps) {
  const {
    onNextClick,
    onPreviousClick,
    pageInfo,
    totalCount,
    page,
    allSelected,
    selectedIds,
    type,
    downloadToExcel,
  } = props;

  const { hasNextPage, hasPreviousPage } = pageInfo;
  const { searchQuery } = useRouter();
  const q = searchQuery.get("q");
  return (
    <header className="navbar navbar--sub navbar--has-tabs">
      <div className="h-100">
        <NavLink
          className="form-control--value tab-trigger"
          to={q ? `/kursus?q=${q}` : `/kursus`}
        >
          Kurser
        </NavLink>
        <NavLink
          className="form-control--value tab-trigger"
          to={q ? `/linje?q=${q}` : `/linje`}
        >
          Linjer
        </NavLink>
      </div>

      <div className="justify-content-end gap-5">
        <DropdownRoot className="c-dropdown-default--actions">
          <HandlingerDropdownTrigger
            allSelected={allSelected}
            selectedIdsLength={selectedIds.length}
            totalCount={totalCount}
            type={type}
            badgeSolid
          />
          <DropdownContent>
            <DropdownItem onClick={downloadToExcel}>
              <DropdownItemIcon>
                <DownloadListIcon />
              </DropdownItemIcon>
              <span>Hent til Excel</span>
            </DropdownItem>
          </DropdownContent>
        </DropdownRoot>
        <Pagination
          hasNextPage={hasNextPage}
          hasPreviousPage={hasPreviousPage}
          page={page}
          totalCount={totalCount}
          onPreviousClick={onPreviousClick}
          onNextClick={onNextClick}
        />
      </div>
    </header>
  );
}
